import { useState } from "react";

import { isNotEmpty } from "@/libs/utils";

import CommonInput from "@/components/Common/Input";
import CommonPlusButton from "@/components/Common/PlusButton";
import KeywordItem from "@/components/KeywordItem";

type Props = {
  data: string[];
  setData: (data: string[]) => void;
};

export default function BidNumberSearchItem({ data, setData }: Props) {
  const [inputText, setInputText] = useState<string>("");

  const handleClickPlus = () => {
    if (isNotEmpty(inputText) && !data.includes(inputText)) {
      setData([...data, inputText]);
      setInputText("");
    }
  };

  const handleDeleteItem = (index: number) => {
    setData([...data.toSpliced(index, 1)]);
  };

  return (
    <div className="flex items-center gap-[8px]">
      <div className="w-[80px]">
        <div className="text-gray-B text-xs font-bold">공고 번호</div>
      </div>
      <CommonInput
        className="min-w-[180px]"
        placeholder="공고 번호를 입력해보세요"
        defaultValue={inputText}
        onChange={(value) => setInputText(value)}
        onKeyDownEnter={() => {
          handleClickPlus();
        }}
      />
      <CommonPlusButton onClick={handleClickPlus} />
      <div className="flex gap-[8px] overflow-x-auto">
        {data.map((item, index) => (
          <KeywordItem
            key={index}
            index={index}
            label={item}
            className="bg-dark-brown"
            onDelete={() => handleDeleteItem(index)}
          />
        ))}
      </div>
    </div>
  );
}
